import React, { createContext, useContext, useEffect, useState } from 'react';

export const DeviceSizeContext = createContext([{}, () => null]);

export const DeviceSizeProvider = ({ children }) => {
  const [deviceSize, setDeviceSize] = useState();

  const handleWindowResize = () => {
    const { clientWidth } = document.documentElement;

    if (clientWidth >= 1680) setDeviceSize('xxl');
    else if (clientWidth >= 1400) setDeviceSize('xl');
    else if (clientWidth >= 1200) setDeviceSize('sxl');
    else if (clientWidth >= 992) setDeviceSize('lg');
    else if (clientWidth >= 768) setDeviceSize('md');
    else if (clientWidth >= 576) setDeviceSize('sm');
    else setDeviceSize('xs');
  };

  useEffect(() => {
    handleWindowResize();

    window.addEventListener('resize', handleWindowResize);

    return () => window.removeEventListener('resize', handleWindowResize);
  }, []);

  return (
    <DeviceSizeContext.Provider value={deviceSize}>
      {children}
    </DeviceSizeContext.Provider >
  );
};

export const useDeviceSize = () => useContext(DeviceSizeContext);